import { motion } from "framer-motion";
import { Fingerprint } from "@phosphor-icons/react";

const COLORS = {
  safe: { ring: "#00E5FF", glow: "rgba(0,229,255,0.55)", text: "text-aqua" },
  warning: { ring: "#FF9900", glow: "rgba(255,153,0,0.55)", text: "text-warn" },
  critical: { ring: "#FF2A55", glow: "rgba(255,42,85,0.55)", text: "text-danger" },
  expired: { ring: "#FF2A55", glow: "rgba(255,42,85,0.7)", text: "text-danger" },
};

const GiantButton = ({ onClick, pressing, disabled, statusKey = "safe", ...rest }) => {
  const c = COLORS[statusKey] || COLORS.safe;

  return (
    <motion.button
      type="button"
      onClick={onClick}
      disabled={disabled}
      data-testid={rest["data-testid"] || "giant-check-in-button"}
      className="relative outline-none focus:outline-none group"
      whileTap={{ scale: 0.94 }}
      animate={{
        scale: [1, 1.025, 1],
        boxShadow: [
          `0 0 0px ${c.glow}, inset 0 0 0px rgba(255,255,255,0)`,
          `0 0 70px ${c.glow}, inset 0 0 28px rgba(255,255,255,0.04)`,
          `0 0 0px ${c.glow}, inset 0 0 0px rgba(255,255,255,0)`,
        ],
      }}
      transition={{
        duration: 3.4,
        ease: "easeInOut",
        repeat: Infinity,
      }}
      style={{
        width: "min(72vw, 320px)",
        height: "min(72vw, 320px)",
        borderRadius: "9999px",
        background:
          "radial-gradient(circle at 50% 35%, #1A1A20 0%, #121216 55%, #0A0A0E 100%)",
        border: `2px solid ${c.ring}`,
      }}
    >
      {/* Inner ring */}
      <div
        className="absolute inset-3 rounded-full pointer-events-none"
        style={{
          border: `1px dashed ${c.ring}55`,
        }}
      />
      {/* Inner core */}
      <div
        className="absolute inset-8 rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at 50% 50%, rgba(0,229,255,0.10) 0%, rgba(0,0,0,0) 70%)",
        }}
      />

      <div className="relative flex flex-col items-center justify-center gap-2 select-none">
        <Fingerprint
          size={88}
          weight="duotone"
          className={c.text + " drop-shadow-[0_0_18px_rgba(0,229,255,0.45)]"}
        />
        <span className="mono font-mono text-[10px] tracking-[0.35em] uppercase text-white/60 mt-1">
          {pressing ? "Registrando..." : "Toca para check-in"}
        </span>
      </div>

      {/* Outer pulse halo */}
      <motion.div
        className="absolute inset-0 rounded-full pointer-events-none"
        animate={{ opacity: [0.0, 0.35, 0.0], scale: [1, 1.18, 1.32] }}
        transition={{ duration: 3.4, ease: "easeOut", repeat: Infinity }}
        style={{
          border: `1px solid ${c.ring}`,
          filter: "blur(0.5px)",
        }}
      />
    </motion.button>
  );
};

export default GiantButton;
